import { ITokenUserContext } from '../dtos/responses/ITokenUserContext';
import { SystemRoleEnum } from '../../../system-management/system-roles/enums/role-type.enum';
import { AccountTypeEnum } from '../../../system-management/accounts/enums/account-type.enum';

export interface IUserContext {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  accountId: string;
  systemRoles: string[];
  specializedRoles: string[];
  permissions: string[];
  accountTypes: string[];
}

export class UserContext implements IUserContext {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  accountId: string;
  systemRoles: string[];
  specializedRoles: string[];
  permissions: string[];
  accountTypes: string[];

  constructor(userContext: IUserContext) {
    this.id = userContext.id;
    this.firstName = userContext.firstName;
    this.lastName = userContext.lastName;
    this.email = userContext.email;
    this.accountId = userContext.accountId;
    this.systemRoles = userContext.systemRoles;
    this.specializedRoles = userContext.specializedRoles;
    this.permissions = userContext.permissions;
    this.accountTypes = userContext.accountTypes;
  }

  static create(userContext: IUserContext) {
    return new UserContext(userContext);
  }

  static createFromNew(newUserContext: ITokenUserContext) {
    let userContext: IUserContext = {
      id: newUserContext.User.Id,
      firstName: newUserContext.User.FirstName,
      lastName: newUserContext.User.LastName,
      email: newUserContext.User.Email,
      accountId: newUserContext.User.AccountId,
      systemRoles: newUserContext.SystemRoles,
      specializedRoles: newUserContext.SpecializedRoles,
      permissions: newUserContext.Permissions,
      accountTypes: []
    };
    return new UserContext(userContext);
  }

  public hasPermission(permissionName: string): boolean {
    if (this.hasSystemRole(SystemRoleEnum.SYSTEM_GLOBAL_ADMIN)) {
      return true;
    }
    return this.permissions.includes(permissionName);
  }

  public hasSystemRole(systemRole: string): boolean {
    return this.systemRoles.includes(systemRole);
  }

  public hasSpecializedRole(specializedRole: string): boolean {
    return this.specializedRoles.includes(specializedRole);
  }

  public belongsToSystemAccount(): boolean {
    return this.belongsToAccountOfType(AccountTypeEnum.SYSTEM);
  }

  public belongsToAccountOfType(accountType: string): boolean {
    return this.accountTypes.includes(accountType);
  }

  public getFullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  public isAdmin(specialziedRole?: string): boolean {
    return (
      this.hasSystemRole(SystemRoleEnum.ACCOUNT_GLOBAL_ADMIN) ||
      (!!specialziedRole && this.hasSpecializedRole(specialziedRole))
    );
  }

  public isAdminWithPermission(permissionName: string, specialziedRole?: string): boolean {
    return this.isAdmin(specialziedRole) && this.hasPermission(permissionName);
  }

  public isAdminWithPermissionAndBelongsToAccountType(
    permissionName: string,
    accountType: string,
    specialziedRole?: string
  ): boolean {
    return this.isAdminWithPermission(permissionName, specialziedRole) && this.belongsToAccountOfType(accountType);
  }
}
